import { isDesktop, isMac, isWindows, isLinux } from '@trello/browser';
import { analyticsWebClientEnv, clientVersion, locale } from '@trello/config';
import AnalyticsWebClient, {
  envType,
  originType,
  platformType,
  AnalyticsWebclientConfig,
} from '@atlassiansox/analytics-web-client';

type EnvironmentVariableType = 'DEV' | 'STAGING' | 'PROD';

const config = {
  env: envType[analyticsWebClientEnv as EnvironmentVariableType],
  product: 'trello',
  version: clientVersion,
  origin: isDesktop() ? originType.DESKTOP : originType.WEB,
  platform: null,
  locale,
} as AnalyticsWebclientConfig;

if (isDesktop()) {
  switch (true) {
    case isMac():
      config.platform = platformType.MAC;
      break;
    case isWindows():
      config.platform = platformType.WINDOWS;
      break;
    case isLinux():
      config.platform = platformType.LINUX;
      break;
    default:
  }
}

export const Analytics = new AnalyticsWebClient(config);
